<template>
    <v-card>
        <v-card-title v-text="`${$props.tree.node_name} Site Information`"></v-card-title>

        <v-card-text>
            <p v-html="`${htmlLinks} ${htmlTree}`"></p>
        </v-card-text>

        <v-divider />
        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text color="#ffffff" @click="$emit('close')">Close</v-btn>
            <v-btn text color="#ffffff" @click="print">Print</v-btn>
        </v-card-actions>
        
    </v-card>
</template>

<script>
export default {
  name: 'FullView',
  props: ['tree', 'values'],
  components: {

  },
  data: () => ({
      htmlTree: '',
      htmlLinks: ''
  }),

  computed: {
  },

  methods: {
      print: function() {
          let printWindow = window.open('', 'PRINT', 'height=400,width=600');
          let contents = `<html>
            <head>
                <title>${this.$props.tree.node_name} Site Information</title>
            </head>
            <body>
                <h1>${this.$props.tree.node_name} Site Information</h1>
                <br><br>
                ${this.htmlTree}
            </body>
            </html>`;
          printWindow.document.write(contents);

        //   printWindow.document.close(); // necessary for IE >= 10
        //   printWindow.focus(); // necessary for IE >= 10*/

          printWindow.print();
          printWindow.close();
      },

      buildHtmlTree: function() {
          let tree = this.$props.tree;
          let nodeValues = this.$props.values;
          let htmlTree = ``;
          let htmlLinks = '';
          let roots = tree.children;

          // Build root links
          htmlLinks += `<div class="links-list">`;
          for(let root of roots) {
              htmlLinks += `\n<a href="#root-${root.node_id}">${root.node_name}</a><br>`;
          }
          htmlLinks += `\n</div><br><br>`;


          let getNodeValue = function(nodeId) {
              let node = nodeValues.find(n => {
                  return (n.node_id == nodeId);
              });
              if(node) {
                  if(node.item_id == -1) {
                      return `: <b><i>${node.node_value}</i></b>`;
                  }
                  else {
                      let valueList = `: <b><i>${node.node_value}</i>\n<ol>\n`;
                      for(let val of node.item_values) {
                          valueList += `<li>${val.object_field.field_name}: ${val.item_value}</li>\n`;
                      }
                      valueList += `</b></ol>`;
                      return valueList;
                  }
              }
              return ':';
          }

          // Recursive build roots
          let rcur = function(nodes) {
              nodes.forEach(node => {
                  htmlTree += `<li>${node.node_name}`;
                  if(node.children.length) {
                      htmlTree += `\n<ul>\n`;
                      rcur(node.children);
                      htmlTree += `</ul>\n`;
                  }
                  else {
                      // leaf node. go get value.
                      htmlTree += `${getNodeValue(node.node_id)}`;
                  }
                  htmlTree += `</li>\n`;
              })
          };


          htmlTree += `<div>\n`;
          htmlTree += `\n<ul>\n`;
          for(let root of roots) {
              htmlTree += `<li id="root-${root.node_id}">${root.node_name}`;
              if(root.children.length) {
                  htmlTree += `</li>\n<ul>\n`;
                  rcur(root.children);
                  htmlTree += `</ul>\n`;
              }
              else {
                  // root node is a leaf node. go get value.
                  htmlTree += `${getNodeValue(root.node_id)}</li>`;
              }
          }
          htmlTree += `</ul>\n`;
          htmlTree += `</div>`;
          this.htmlLinks = htmlLinks;
          this.htmlTree = htmlTree;
      }
  },

  mounted() {
      this.buildHtmlTree();
  }

  
};
</script>
